import { A } from '@adornis/base/env-info.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Names } from '@ils/static/names.js';

@Entity()
export class Instruction extends AdornisEntity {
  static override _class = Names.Instruction._class;

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => String)
  question!: string;

  @Field(type => String)
  description!: string;
}
